import { render, staticRenderFns } from "./SuspendWindow.vue?vue&type=template&id=7d1c0506&scoped=true&"
import script from "./SuspendWindow.vue?vue&type=script&lang=js&"
export * from "./SuspendWindow.vue?vue&type=script&lang=js&"
import style0 from "./SuspendWindow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SuspendWindow.vue?vue&type=style&index=1&id=7d1c0506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1c0506",
  null
  
)

export default component.exports